export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

export const METRIC_OPTIONS = [
  { key: 'oee.overall', labelKey: 'metric.oeeOverall', format: (v) => `${v ?? 0}%` },
  { key: 'oee.availability', labelKey: 'metric.availability', format: (v) => `${v ?? 0}%` },
  { key: 'oee.performance', labelKey: 'metric.performance', format: (v) => `${v ?? 0}%` },
  { key: 'oee.quality', labelKey: 'metric.quality', format: (v) => `${v ?? 0}%` },
  { key: 'utilization', labelKey: 'metric.utilization', format: (v) => `${v ?? 0}%` },
  { key: 'capacity.current', labelKey: 'metric.currentOutput', format: (v) => `${v ?? 0} t/h` },
  { key: 'capacity.max', labelKey: 'metric.maxCapacity', format: (v) => `${v ?? 0} t/h` },
  { key: 'alerts.length', labelKey: 'metric.activeAlerts', format: (v) => `${v ?? 0}` },
  { key: 'equipment.hoursRun', labelKey: 'metric.hoursRun', format: (v) => `${(v ?? 0).toLocaleString()} h` },
];
